
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { featuredProducts } from '../../mocks/products';
import Button from '../../components/base/Button';

export default function ProductPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState<any>(null);
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState(0);

  useEffect(() => {
    const foundProduct = featuredProducts.find(p => p.id === parseInt(id || '0'));
    if (foundProduct) {
      setProduct({
        ...foundProduct,
        description: 'قهوة فاخرة مختارة بعناية من أجود أنواع البن العربي الأصيل. تتميز بطعمها الغني ونكهتها المميزة التي تأسر الحواس. محمصة بطريقة تقليدية للحصول على أفضل طعم ورائحة.',
        specifications: [
          'المنشأ: المملكة العربية السعودية',
          'نوع التحميص: متوسط',
          'الوزن: 250 جرام',
          'تاريخ التحميص: طازج',
          'مستوى الكافيين: متوسط'
        ],
        images: [
          foundProduct.image,
          foundProduct.image,
          foundProduct.image
        ]
      });
    }
  }, [id]);

  const handleAddToCart = () => {
    // إضافة المنتج للسلة
    const cartItems = JSON.parse(localStorage.getItem('cartItems') || '[]');
    const existingItem = cartItems.find((item: any) => item.id === product.id);
    
    if (existingItem) {
      existingItem.quantity += quantity;
    } else {
      cartItems.push({ ...product, quantity });
    }
    
    localStorage.setItem('cartItems', JSON.stringify(cartItems));
    
    // إظهار رسالة نجاح
    alert('تم إضافة المنتج إلى السلة بنجاح!');
  };

  if (!product) {
    return (
      <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-[#D4AF37] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#777777]">جاري التحميل...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAFAFA] pb-20">
      {/* Header */}
      <div className="fixed top-0 w-full bg-white z-40 shadow-sm">
        <div className="flex items-center justify-between p-4">
          <button onClick={() => navigate(-1)} className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-xl text-[#4B2E05]"></i>
          </button>
          <h1 className="text-lg font-bold text-[#4B2E05]">تفاصيل المنتج</h1>
          <button className="w-10 h-10 flex items-center justify-center">
            <i className="ri-heart-line text-xl text-[#777777]"></i>
          </button>
        </div>
      </div>

      <div className="pt-20">
        {/* Product Images */}
        <div className="bg-white mb-4">
          <div className="relative">
            <img 
              src={product.images[selectedImage]} 
              alt={product.name}
              className="w-full h-80 object-cover"
            />
            {product.originalPrice && (
              <div className="absolute top-4 left-4 bg-[#D4AF37] text-white px-3 py-1 rounded-full text-sm font-bold">
                خصم {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}%
              </div>
            )}
          </div>
          
          {/* Image Thumbnails */}
          <div className="flex gap-2 p-4">
            {product.images.map((image: string, index: number) => (
              <button
                key={index}
                onClick={() => setSelectedImage(index)}
                className={`w-16 h-16 rounded-lg overflow-hidden border-2 ${
                  selectedImage === index ? 'border-[#D4AF37]' : 'border-gray-200'
                }`}
              >
                <img src={image} alt="" className="w-full h-full object-cover" />
              </button>
            ))}
          </div>
        </div>

        {/* Product Info */}
        <div className="bg-white p-4 mb-4">
          <h1 className="text-xl font-bold text-[#4B2E05] mb-2">{product.name}</h1>
          
          {/* Rating */}
          <div className="flex items-center gap-2 mb-4">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <i 
                  key={i} 
                  className={`ri-star-${i < product.rating ? 'fill' : 'line'} text-[#D4AF37]`}
                ></i>
              ))}
            </div>
            <span className="text-[#777777] text-sm">({product.rating}.0)</span>
          </div>

          {/* Price */}
          <div className="flex items-center gap-3 mb-4">
            <span className="text-2xl font-bold text-[#4B2E05]">{product.price} ر.س</span>
            {product.originalPrice && (
              <span className="text-lg text-[#777777] line-through">{product.originalPrice} ر.س</span>
            )}
          </div>

          {/* Description */}
          <div className="mb-6">
            <h3 className="text-lg font-bold text-[#4B2E05] mb-2">الوصف</h3>
            <p className="text-[#777777] leading-relaxed">{product.description}</p>
          </div>

          {/* Specifications */}
          <div className="mb-6">
            <h3 className="text-lg font-bold text-[#4B2E05] mb-3">المواصفات</h3>
            <div className="space-y-2">
              {product.specifications.map((spec: string, index: number) => (
                <div key={index} className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#D4AF37] rounded-full"></div>
                  <span className="text-[#777777]">{spec}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Quantity & Add to Cart */}
        <div className="bg-white p-4">
          <div className="flex items-center justify-between mb-6">
            <span className="text-lg font-bold text-[#4B2E05]">الكمية</span>
            <div className="flex items-center gap-3">
              <button 
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                className="w-10 h-10 bg-[#F5F5F5] rounded-full flex items-center justify-center"
              >
                <i className="ri-subtract-line text-[#4B2E05]"></i>
              </button>
              <span className="text-lg font-bold text-[#4B2E05] min-w-[2rem] text-center">{quantity}</span>
              <button 
                onClick={() => setQuantity(quantity + 1)}
                className="w-10 h-10 bg-[#F5F5F5] rounded-full flex items-center justify-center"
              >
                <i className="ri-add-line text-[#4B2E05]"></i>
              </button>
            </div>
          </div>

          <Button 
            onClick={handleAddToCart}
            className="w-full bg-[#D4AF37] text-white py-4 rounded-xl font-bold text-lg"
          >
            إضافة إلى السلة - {(product.price * quantity).toLocaleString()} ر.س
          </Button>
        </div>

        {/* Similar Products */}
        <div className="bg-white p-4 mt-4">
          <h3 className="text-lg font-bold text-[#4B2E05] mb-4">منتجات مشابهة</h3>
          <div className="grid grid-cols-2 gap-3">
            {featuredProducts.filter(p => p.id !== product.id).slice(0, 4).map((item) => (
              <div 
                key={item.id}
                onClick={() => navigate(`/product/${item.id}`)}
                className="bg-[#FAFAFA] rounded-xl p-3 cursor-pointer"
              >
                <img 
                  src={item.image} 
                  alt={item.name}
                  className="w-full h-24 object-cover rounded-lg mb-2"
                />
                <h4 className="text-sm font-bold text-[#4B2E05] mb-1 line-clamp-2">{item.name}</h4>
                <p className="text-[#D4AF37] font-bold text-sm">{item.price} ر.س</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
